import { AIASSISTANT_URL } from '../helper'

export const GET_DX_SUGGESTIONS = AIASSISTANT_URL + '/diagnosis/pdpm-optimize'
